import { t } from 'i18next';

export default function urlPicker({ currentTab, url = '', projectPageUrl = '', customUrl = '', fileUrl = '' }) {
  return {
    currentTab,
    url,
    projectPageUrl,
    customUrl,
    fileUrl,

    init() {
      this.originalUrl = this.url;
      this.modalTrigger = this.$root.querySelector('#modal-trigger');
    },

    setTab(tab) {
      this.currentTab = tab;
      this.clearOtherTabs();
      this.resetUrl();
    },

    resetUrl() {
      this.url = this.originalUrl;
    },

    clearOtherTabs() {
      if (this.currentTab === 'file') {
        if (this.url !== this.projectPageUrl) this.projectPageUrl = '';
        if (this.url !== this.customUrl) this.customUrl = '';
      } else if (this.currentTab === 'page') {
        if (this.url !== this.fileUrl) this.fileUrl = '';
        if (this.url !== this.customUrl) this.customUrl = '';
      } else if (this.currentTab === 'custom') {
        if (this.url !== this.fileUrl) this.fileUrl = '';
        if (this.url !== this.projectPageUrl) this.projectPageUrl = '';
      }
    },

    visibleInput: {
      ['@click']() {
        this.modalTrigger.click();
      },

      ['@mouseover']() {
        this.modalTrigger.classList.add('bg-gray-100', 'border-gray-500');
      },

      ['@mouseout']() {
        this.modalTrigger.classList.remove('bg-gray-100', 'border-gray-500');
      },
    },
  };
}
